import i18n from '@i18next/i18n';
import { AnimType } from '@tencent/slide-sdk-model';
import {
    EMPH_TRANSPARENCY_ICON, PULSE_ICON, ROTATE_ICON, SCALE_ICON, APPEAR_ICON, ENTR_ROTATE_ICON,
    ENTR_SCALE_ICON, ENTR_BASIC_ZOOM_ICON, ENTR_BASIC_SWIVEL_ICON, ENTR_BLINDS_ICON,
    ENTR_BOOMERANG_ICON, ENTR_CENTER_REVOLVE_ICON, ENTR_CREDITS_ICON, FADE_IN_ICON,
    FLOAT_IN_ICON, FLY_IN_ICON, ENTR_GROW_TURN_ICON, ENTR_PINWHEEL_ICON, RISE_UP_ICON,
    ENTR_SPINNER_ICON, SPREAD_ICON, ENTR_STRETCH_ICON, EXIT_BASIC_SWIVEL_ICON,
    EXIT_SCALE_ICON, EXIT_BASIC_ZOOM_ICON, EXIT_BLINDS_ICON, EXIT_BOOMERANG_ICON,
    EXIT_CENTER_REVOLVE_ICON, EXIT_COLLAPSE_ICON, EXIT_SPREAD_ICON, EXIT_CREDITS_ICON,
    DISAPPEAR_ICON, FADE_OUT_ICON, FLOAT_OUT_ICON, FLY_OUT_ICON, EXIT_PINWHEEL_ICON,
    EXIT_ROTATE_ICON, EXIT_SHRINK_TURN_ICON, EXIT_SINK_DOWN_ICON, EXIT_SPINNER_ICON,
    EXIT_STRETCH_ICON, ARC_ICON, STRAIGHT_LINE_ICON, CYCLE_ICON, SHAPE_ICON, TURN_ICON,
    ENTR_CHECKERBOARD_ICON, ENTR_DISSOLVE_ICON, CUT_OUT_ICON, ENTR_RANDOMBARS_ICON, ENTR_SHAPE_ICON,
    ENTR_SPLIT_ICON, ENTR_STRIPS_ICON, ENTR_WEDGE_ICON, ENTR_WHEEL_ICON, ENTR_WIPE_ICON,
    CURVE_UP_ICON, ENTR_FLOAT_ICON, SPIRAL_IN_ICON, EXIT_CHECKERBOARD_ICON, EXIT_DISSOLVE_ICON,
    EXIT_RANDOMBARS_ICON, EXIT_SHAPE_ICON, EXIT_SPLIT_ICON, EXIT_STRIPS_ICON, EXIT_WEDGE_ICON,
    EXIT_WHEEL_ICON, EXIT_WIPE_ICON, CURVE_DOWN_ICON, EXIT_FLOAT_ICON, SPIRAL_OUT_ICON, CUT_IN_ICON,
    ENTR_BOUNCE_ICON, EXIT_BOUNCE_ICON,
    FILL_COLOR_ICON, FONT_COLOR_ICON, LINE_COLOR_ICON, BRUSH_COLOR_ICON, COMPLEMENTARY_COLOR_ICON,
    COMPLEMENTARY_COLOR2_ICON, CONTRASTING_COLOR_ICON, DARKEN_ICON, DESATURATE_ICON,
    LIGHTEN_ICON, OBJECT_COLOR_ICON, COLOR_PULSE_ICON, GROW_WITH_COLOR_ICON,
} from './anim-icon';

const getList = (arr: Array<any>) => arr.reduce((previous, current) => [...previous, ...current.children], []);

export enum PresetClassTypes {
    NONE = 'none',
    ENTR = 'entr',
    EXIT = 'exit',
    EMPH = 'emph',
    PATH = 'path',
    MEDIA = 'mediacall',
}

export enum AnimEventType {
    MODIFY_ANIM_TYPE = 'modify_anim_type',
}

export interface IAnimConfig {
    id: AnimType;
    label: string;
    presetClass: PresetClassTypes;
    icon?: string;
    disabled?: boolean;
}

export interface IAnimCategory {
    id: string;
    label: string;
    children: IAnimConfig[];
}

export const ENTR_LIST: IAnimCategory[] = [
    {
        id: 'basic',
        label: i18n.t('基本'),
        children: [
            {
                id: AnimType.Appear,
                label: i18n.t('出现'),
                icon: APPEAR_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrBlinds,
                label: i18n.t('百叶窗'),
                icon: ENTR_BLINDS_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrCheckerboard,
                label: i18n.t('棋盘'),
                icon: ENTR_CHECKERBOARD_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.DissolveIn,
                label: i18n.t('向内溶解'),
                icon: ENTR_DISSOLVE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.FlyIn,
                label: i18n.t('飞入'),
                icon: FLY_IN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.CutIn,
                label: i18n.t('切入动画'),
                icon: CUT_IN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrRandomBars,
                label: i18n.t('随机线条'),
                icon: ENTR_RANDOMBARS_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                // 形状默认是圆形，所有顶部 tab 栏和动画侧边栏中选中后默认以圆形绑定，
                // 后面可以通过属性选择修改为其他形状
                // 退出同理
                id: AnimType.EntrShapeCircle,
                label: i18n.t('形状'),
                icon: ENTR_SHAPE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrSplit,
                label: i18n.t('劈裂'),
                icon: ENTR_SPLIT_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrStrips,
                label: i18n.t('阶梯状'),
                icon: ENTR_STRIPS_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrWedge,
                label: i18n.t('楔入'),
                icon: ENTR_WEDGE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrWheel,
                label: i18n.t('轮子'),
                icon: ENTR_WHEEL_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrWipe,
                label: i18n.t('擦除'),
                icon: ENTR_WIPE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
        ],
    },
    {
        id: 'subtle',
        label: i18n.t('细微'),
        children: [
            {
                id: AnimType.Spread,
                label: i18n.t('展开'),
                icon: SPREAD_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.FadeIn,
                label: i18n.t('淡入'),
                icon: FADE_IN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EnterRotate,
                label: i18n.t('旋转'),
                icon: ENTR_ROTATE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EnterScale,
                label: i18n.t('缩放'),
                icon: ENTR_SCALE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
        ],
    },
    {
        id: 'moderate',
        label: i18n.t('温和'),
        children: [
            {
                id: AnimType.EntrCenterRevolve,
                label: i18n.t('中心旋转'),
                icon: ENTR_CENTER_REVOLVE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.FloatUpIn,
                label: i18n.t('浮入'),
                icon: FLOAT_IN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrGrowTurn,
                label: i18n.t('翻转式由远及近'),
                icon: ENTR_GROW_TURN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrRiseUp,
                label: i18n.t('升起'),
                icon: RISE_UP_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrSpinner,
                label: i18n.t('回旋'),
                icon: ENTR_SPINNER_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrBasicZoom,
                label: i18n.t('基本缩放'),
                icon: ENTR_BASIC_ZOOM_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrStretch,
                label: i18n.t('伸展'),
                icon: ENTR_STRETCH_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
        ],
    },
    {
        id: 'exciting',
        label: i18n.t('华丽'),
        children: [
            {
                id: AnimType.EntrBoomerang,
                label: i18n.t('飞旋'),
                icon: ENTR_BOOMERANG_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrBounce,
                label: i18n.t('弹跳'),
                icon: ENTR_BOUNCE_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.CurveUp,
                label: i18n.t('曲线向上'),
                icon: CURVE_UP_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrFloat,
                label: i18n.t('浮动'),
                icon: ENTR_FLOAT_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrPinwheel,
                label: i18n.t('玩具风车'),
                icon: ENTR_PINWHEEL_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.SpiralIn,
                label: i18n.t('旋转飞入'),
                icon: SPIRAL_IN_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrBasicSwivel,
                label: i18n.t('基本旋转'),
                icon: ENTR_BASIC_SWIVEL_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
            {
                id: AnimType.EntrCredits,
                label: i18n.t('字幕式'),
                icon: ENTR_CREDITS_ICON,
                presetClass: PresetClassTypes.ENTR,
            },
        ],
    },
];

export const EMPH_LIST: IAnimCategory[] = [
    {
        id: 'basic',
        label: i18n.t('基本'),
        children: [
            {
                id: AnimType.FillColor,
                label: i18n.t('填充颜色'),
                icon: FILL_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.FontColor,
                label: i18n.t('字体颜色'),
                icon: FONT_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Scale,
                label: i18n.t('放大/缩小'),
                icon: SCALE_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.LineColor,
                label: i18n.t('线条颜色'),
                icon: LINE_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Rotate,
                label: i18n.t('陀螺旋'),
                icon: ROTATE_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.EmphTransparency,
                label: i18n.t('透明'),
                icon: EMPH_TRANSPARENCY_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
        ],
    },
    {
        id: 'subtle',
        label: i18n.t('细微'),
        children: [
            {
                id: AnimType.BrushColor,
                label: i18n.t('画笔颜色'),
                icon: BRUSH_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.ComplementaryColor,
                label: i18n.t('补色'),
                icon: COMPLEMENTARY_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.ComplementaryColor2,
                label: i18n.t('补色2'),
                icon: COMPLEMENTARY_COLOR2_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.ContrastingColor,
                label: i18n.t('对比色'),
                icon: CONTRASTING_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Darken,
                label: i18n.t('加深'),
                icon: DARKEN_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Desaturate,
                label: i18n.t('不饱和'),
                icon: DESATURATE_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Lighten,
                label: i18n.t('变淡'),
                icon: LIGHTEN_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.ObjectColor,
                label: i18n.t('对象颜色'),
                icon: OBJECT_COLOR_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
            {
                id: AnimType.Plus,
                label: i18n.t('脉冲'),
                icon: PULSE_ICON,
                presetClass: PresetClassTypes.EMPH,
            },
        ],
    },
    {
        id: 'moderate',
        label: i18n.t('温和'),
        children: [{
            id: AnimType.ColorPulse,
            label: i18n.t('彩色脉冲'),
            icon: COLOR_PULSE_ICON,
            presetClass: PresetClassTypes.EMPH,
        },
        {
            id: AnimType.GrowWithColor,
            label: i18n.t('彩色延伸'),
            icon: GROW_WITH_COLOR_ICON,
            presetClass: PresetClassTypes.EMPH,
        }],
    },
];

export const EXIT_LIST: IAnimCategory[] = [
    {
        id: 'basic',
        label: i18n.t('基本'),
        children: [
            {
                id: AnimType.Disappear,
                label: i18n.t('消失'),
                icon: DISAPPEAR_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitBlinds,
                label: i18n.t('百叶窗'),
                icon: EXIT_BLINDS_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitCheckerboard,
                label: i18n.t('棋盘'),
                icon: EXIT_CHECKERBOARD_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.DissolveOut,
                label: i18n.t('向外溶解'),
                icon: EXIT_DISSOLVE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.FlyOut,
                label: i18n.t('飞出'),
                icon: FLY_OUT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.CutOut,
                label: i18n.t('切出动画'),
                icon: CUT_OUT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitRandomBars,
                label: i18n.t('随机线条'),
                icon: EXIT_RANDOMBARS_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitShapeCircle,
                label: i18n.t('形状'),
                icon: EXIT_SHAPE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitSplit,
                label: i18n.t('劈裂'),
                icon: EXIT_SPLIT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitStrips,
                label: i18n.t('阶梯状'),
                icon: EXIT_STRIPS_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitWedge,
                label: i18n.t('楔入'),
                icon: EXIT_WEDGE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitWheel,
                label: i18n.t('轮子'),
                icon: EXIT_WHEEL_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitWipe,
                label: i18n.t('擦除'),
                icon: EXIT_WIPE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
        ],
    },
    {
        id: 'subtle',
        label: i18n.t('细微'),
        children: [
            {
                id: AnimType.ExitSpread,
                label: i18n.t('收缩'),
                icon: EXIT_SPREAD_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.FadeOut,
                label: i18n.t('淡出'),
                icon: FADE_OUT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitRotate,
                label: i18n.t('旋转'),
                icon: EXIT_ROTATE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitScale,
                label: i18n.t('缩放'),
                icon: EXIT_SCALE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
        ],
    },
    {
        id: 'moderate',
        label: i18n.t('温和'),
        children: [
            {
                id: AnimType.ExitCenterRevolve,
                label: i18n.t('中心旋转'),
                icon: EXIT_CENTER_REVOLVE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.FloatUpOut,
                label: i18n.t('浮出'),
                icon: FLOAT_OUT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitShrinkTurn,
                label: i18n.t('收缩并旋转'),
                icon: EXIT_SHRINK_TURN_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitSinkDown,
                label: i18n.t('下沉'),
                icon: EXIT_SINK_DOWN_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitSpinner,
                label: i18n.t('回旋'),
                icon: EXIT_SPINNER_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitBasicZoom,
                label: i18n.t('基本缩放'),
                icon: EXIT_BASIC_ZOOM_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitStretch,
                label: i18n.t('伸展'),
                icon: EXIT_STRETCH_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitCollapse,
                label: i18n.t('层叠'),
                icon: EXIT_COLLAPSE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
        ],
    },
    {
        id: 'exciting',
        label: i18n.t('华丽'),
        children: [
            {
                id: AnimType.ExitBoomerang,
                label: i18n.t('飞旋'),
                icon: EXIT_BOOMERANG_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitBounce,
                label: i18n.t('弹跳'),
                icon: EXIT_BOUNCE_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.CurveDown,
                label: i18n.t('向下曲线'),
                icon: CURVE_DOWN_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitFloat,
                label: i18n.t('浮动'),
                icon: EXIT_FLOAT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitPinwheel,
                label: i18n.t('玩具风车'),
                icon: EXIT_PINWHEEL_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.SpiralOut,
                label: i18n.t('旋转飞出'),
                icon: SPIRAL_OUT_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitBasicSwivel,
                label: i18n.t('基本旋转'),
                icon: EXIT_BASIC_SWIVEL_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
            {
                id: AnimType.ExitCredits,
                label: i18n.t('字幕式'),
                icon: EXIT_CREDITS_ICON,
                presetClass: PresetClassTypes.EXIT,
            },
        ],
    },
];

export const PATH_LIST: IAnimCategory[] = [
    {
        id: 'basic',
        label: i18n.t('基本'),
        children: [
            {
                id: AnimType.Arc,
                label: i18n.t('弧形'),
                icon: ARC_ICON,
                presetClass: PresetClassTypes.PATH,
            },
            {
                id: AnimType.StraightLine,
                label: i18n.t('直线'),
                icon: STRAIGHT_LINE_ICON,
                presetClass: PresetClassTypes.PATH,
            },
            {
                id: AnimType.Cycle,
                label: i18n.t('循环'),
                icon: CYCLE_ICON,
                presetClass: PresetClassTypes.PATH,
            },
            {
                id: AnimType.Shape,
                label: i18n.t('形状'),
                icon: SHAPE_ICON,
                presetClass: PresetClassTypes.PATH,
            },
            {
                id: AnimType.Turn,
                label: i18n.t('转弯'),
                icon: TURN_ICON,
                presetClass: PresetClassTypes.PATH,
            },
        ],
    },
];
export const ENTR_ANIM_LIST = getList(ENTR_LIST);

export const EMPH_ANIM_LIST = getList(EMPH_LIST);

export const EXIT_ANIM_LIST = getList(EXIT_LIST);

export const PATH_ANIM_LIST = getList(PATH_LIST);
